import { FunctionComponent } from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type ManagementChartEmptyStateProps = {
  /** i18n key for the empty / idle message */
  messageKey?: string;
};

/**
 * Idle empty copy when a Management chart has no series points (avoids a blank Recharts canvas).
 */
export const ManagementChartEmptyState: FunctionComponent<ManagementChartEmptyStateProps> = ({
  messageKey = "_management_chartEmpty"
}) => {
  const { t } = useTranslation();

  return (
    <Typography variant="body2" color="text.secondary" data-testid="management-chart-empty">
      {t(messageKey)}
    </Typography>
  );
};
